/**
 * @fileoverview Aggregate Mail route (MOR-529).
 *
 * URL: /dashboard/mail — recent threads across every job mailbox the user can
 * access. Per-job mailboxes are enabled from the job's own Mail page.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AggregateMailPage } from "@/components/mail/AggregateMailPage";

export const Route = createFileRoute("/_app/_auth/dashboard/_layout/mail")({
  // `settings` lives in the URL so clicking the sidebar "Mail" link (which
  // navigates here with no search) always returns to the inbox view.
  validateSearch: (search: Record<string, unknown>): { settings?: true } => ({
    settings:
      search.settings === true || search.settings === "true" ? true : undefined,
  }),
  component: AggregateMailPage,
});
